var SENTRY_RELEASE;SENTRY_RELEASE={name: "PRAXIS PROETHICA", version: "1.0.0"};